import makeStyles from "e100-react-components/lib/styles/makeStyles";

const useStyles = makeStyles(({ spacing }) => ({
  backIcon: {
    marginLeft: spacing(-1),
  },
  container: {
    padding: spacing(2),
  },
}));

export default useStyles;
